import axios from '~/common/plugins/axios.js'
/* 账户下通用数据，防止重复请求 */
export const state = () => ({
  // 所有联系方式
  contactTypeList: [],

  // 区域列表
  regionList: [],
  //员工类型直接展示审核弹窗
  showCheckAccount:false
})

export const mutations = {
  setContactTypeList(state, data) {
    state.contactTypeList = data;
  },
  setRegionList(state, data) {
    state.regionList = data;
  },
  setShowCheckAccount(state,data){
    state.showCheckAccount=data;
  }
}

export const actions = {
  async getContactType({ state, commit}) {
    if (state.contactTypeList.length > 0) {
      return state.contactTypeList;
    } else {
      const {code, data} = await axios.$post('/rest/store/contact/v3/contactinfotypes/query');
      if (code !== 200) return [];
      commit('setContactTypeList', data);
      return data;
    }
  },
  async getRegionList({ state, commit }) {
    if (state.regionList.length > 0) {
      return state.regionList;
    } else {
      const {code, data} = await axios.$post('/rest/erp/contact/v3/region/query', {
        current: 1,
        page_size: 1000,
        name: ''
      });
      if (code !== 200) return [];
      commit('setRegionList', data);
      return data;
    }
  }
}
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
